const extensionApi = [{
        id: 0,
        browserImg: "images/logo-chrome.svg",
        imgAlt: "chrome",
        browserName: "Add to Chrome",
        version: "Minimum version 62"
    },
    {
        id: 1,
        browserImg: "images/logo-firefox.svg",
        imgAlt: "firefox",
        browserName: "Add to Firefox",
        version: "Minimum version 55"
    },
    {
        id: 2,
        browserImg: "images/logo-opera.svg",
        imgAlt: "opera",
        browserName: "Add to Opera",
        version: "Minimum version 46"
    }
];
export default extensionApi;